import * as z from 'zod'

import { UpdateMediaAiTrainingDataVars } from '@/common/api/params/mediaAiTrainingData'
import { NameLabelMapping } from '@/common/app/message'
import {
  ARTICLE_HTML_MAX_LENGTH,
  MediaAiTrainingData
} from '@/common/model/media/mediaAiTrainingData'

export const articleHtmlSchema = z.object({
  siteId: z.number().readonly(),
  articleHtml: z
    .string()
    .max(ARTICLE_HTML_MAX_LENGTH, `記事HTMLは${ARTICLE_HTML_MAX_LENGTH}文字以内で入力してください`)
})

export type ArticleHtmlSchemaType = z.infer<typeof articleHtmlSchema>

export const articleHtmlNameLabelMapping: NameLabelMapping = {
  articleHtml: '記事HTML'
}

export const makeDefaultArticleHtmlSchema = (siteId: number): ArticleHtmlSchemaType => ({
  siteId,
  articleHtml: ''
})

export const convertArticleHtmlToSchema = (data: MediaAiTrainingData): ArticleHtmlSchemaType => ({
  siteId: data.site_id,
  articleHtml: data.article_html ?? ''
})

export const convertArticleHtmlSchemaToVars = (
  data: ArticleHtmlSchemaType
): UpdateMediaAiTrainingDataVars => ({
  site_id: data.siteId,
  article_html: data.articleHtml
})
